import { useContext, useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { useIsProductAdmin } from '@confluence/current-user/entry-points/useIsProductAdmin.ts';

import { getCompanyHubAnnouncementBanner } from './getCompanyHubAnnouncementBanner.ts';

export const useSaveCompanyHub = () => {
	const { tenantId } = useContext(SPAViewContext);
	const { isProductAdmin } = useIsProductAdmin();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireRequestEvent = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'requested',
				actionSubject: 'saveHubConfirmationDialog',
				source: 'companyHub',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return useCallback(
		async (contentId) => {
			if (!isProductAdmin) {
				fireRequestEvent();
				return;
			}

			const { bannerId, bannerStatus } = await getCompanyHubAnnouncementBanner(contentId, tenantId);

			if (!bannerId) {
				fireRequestEvent();
				return;
			}

			const isBannerActive = !!bannerStatus && bannerStatus !== 'SAVED'; // 'SAVED' means archived

			if (isBannerActive) {
				fireRequestEvent();
			}
		},
		[isProductAdmin, tenantId, fireRequestEvent],
	);
};
